import { render, staticRenderFns } from "./AIAnswer.vue?vue&type=template&id=3349ebfb&"
import script from "./AIAnswer.vue?vue&type=script&lang=js&"
export * from "./AIAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AIAnswer.vue?vue&type=style&index=0&id=3349ebfb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports